(() => {
  'use strict';

  const ROOT_SELECTOR = '.template-product .m-product-info--wrapper, .template-product product-info';
  const EXACT_JUNK = new Set(['null', 'default title', 'unit price /', 'unit price/']);
  const ERROR_JUNK = [
    "couldn't load pickup availability",
    'couldn’t load pickup availability'
  ];

  const isLeafElement = (element) => element && element.children.length === 0;

  const hideJunk = (root) => {
    root.querySelectorAll('span, div, p, small').forEach((element) => {
      if (!isLeafElement(element)) return;
      const text = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text) return;

      if (EXACT_JUNK.has(text) || ERROR_JUNK.some((phrase) => text.includes(phrase))) {
        element.dataset.oneLuxuryCleanupHidden = 'true';
        element.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const improveVariantAccessibility = (root) => {
    root.querySelectorAll('.m-product-option__input').forEach((input) => {
      const label = input.id ? root.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      if (!label) return;

      if (input.disabled) {
        label.setAttribute('aria-disabled', 'true');
      } else {
        label.removeAttribute('aria-disabled');
      }
    });
  };

  const cleanRoots = (roots) => {
    roots.forEach((root) => {
      if (!root || !root.isConnected) return;
      hideJunk(root);
      improveVariantAccessibility(root);
    });
  };

  const allRoots = () => Array.from(document.querySelectorAll(ROOT_SELECTOR)).filter((root) => {
    const parentRoot = root.parentElement ? root.parentElement.closest(ROOT_SELECTOR) : null;
    return !parentRoot;
  });
  const pendingRoots = new Set();
  let scheduled = false;
  const scheduleClean = (roots = allRoots()) => {
    roots.forEach((root) => pendingRoots.add(root));
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      const rootsToClean = Array.from(pendingRoots);
      pendingRoots.clear();
      cleanRoots(rootsToClean);
    });
  };

  const rootsForMutation = (mutation) => {
    const roots = new Set();
    const targetRoot = mutation.target instanceof Element
      ? mutation.target.closest(ROOT_SELECTOR)
      : null;
    if (targetRoot) roots.add(targetRoot);

    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches(ROOT_SELECTOR)) roots.add(node);
      const containingRoot = node.closest(ROOT_SELECTOR);
      if (containingRoot) roots.add(containingRoot);
      node.querySelectorAll(ROOT_SELECTOR).forEach((root) => roots.add(root));
    });
    return roots;
  };

  const observer = new MutationObserver((mutations) => {
    const affectedRoots = new Set();
    mutations.forEach((mutation) => {
      rootsForMutation(mutation).forEach((root) => affectedRoots.add(root));
    });
    if (affectedRoots.size) scheduleClean(affectedRoots);
  });

  const observedRoots = new WeakSet();
  const prepareRoots = () => {
    const roots = allRoots();
    roots.forEach((root) => {
      if (observedRoots.has(root)) return;
      observedRoots.add(root);
      observer.observe(root, { childList: true, subtree: true });
    });
    return roots;
  };

  const initialize = () => {
    const roots = prepareRoots();
    cleanRoots(roots);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('change', (event) => {
    if (event.target && event.target.closest('.template-product variant-picker')) {
      scheduleClean(prepareRoots());
    }
  });

  document.addEventListener('shopify:section:load', () => {
    scheduleClean(prepareRoots());
  });
})();
